module.exports = __webpack_public_path__ + "img/uzbekistan.ef2cba68.svg";